import { WebStorageClient } from "../webStorage.client";
import { WEB_STORAGE_KEYS, HTTP_ENDPOINTS } from "../clients.constants";

export class HttpInterceptors {
  constructor() {}

  request(httpClient, router) {
    httpClient.interceptors.request.use(
      (config) => {
      const { url } = config;

        if ([HTTP_ENDPOINTS.LOGIN].includes(url)) {
          return config;
        } else {
          config.withCredentials = true;
        }

        return config;
      },
      (error) => {
        // console.log('OnReject request interceptor works');
        return Promise.reject(error);
      });
  }

  response(httpClient, router) {
    httpClient.interceptors.response.use(
      (response) => {
        // console.log('OnFulfilled response interceptor works');
        if (response.config?.url?.includes('downloadMovementsReport')) {
          return response;
        } else {
          return response.data;
        }
      },
      async (error) => {
        if (error.status === 401) {
          localStorage.clear();
          sessionStorage.clear();

          if (!window.location.href.includes('login')) {
            window.location.href = 'login';
          }
        }
        if (error.status === 403) {
          console.log('error.message',error);
        }

        throw error?.response || error;
      });
  }
}